import { DialogTitle } from "components/ui/dialog";
import { ChatIconWithBadge } from "../chat-icon-with-badge";
import { CommentsModal } from "../comments-modal";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { useCallback } from "react";
import { MessageCircle } from "lucide-react";

interface CommentCellProps {
  divergenceId: number;
  divergenceName: string;
  isClosed: boolean;
  totalComments: number;
}

export function CommentCell({
  divergenceId,
  divergenceName,
  isClosed,
  totalComments,
}: CommentCellProps) {
  const { handleModal } = useDialogModal();

  const handleOpenCommentsModal = useCallback(() => {
    handleModal({
      isOpen: true,
      element: <CommentsModal
        divergenceId={divergenceId}
        divergenceName={divergenceName}
        isClosed={isClosed}
      />,
      title: (
        <DialogTitle className="text-[24px] font-medium text-[#2B0C1A] leading-[28px] flex items-center gap-2">
          <MessageCircle className="h-5 w-5 text-black" />   Comentários
        </DialogTitle>
      ),
    });
  }, [handleModal, divergenceId, divergenceName, isClosed]);



  // Garantir que totalComments seja sempre válido
  const safeCommentCount = Math.max(0, totalComments || 0);

  return (
    <div className="flex items-center justify-center">
      <ChatIconWithBadge
        commentCount={safeCommentCount}
        onClick={handleOpenCommentsModal}
      />
    </div>
  );
}